// https://beholdr.github.io/maska/ v-mask source

import maska, { mask } from 'maska';
import Mixin from "../../mixin.js";
import FormInputs from "../../services/inputs-service.js";
import Utils from "../../services/utils-service.js";
import Label from "./Label.js";
import Funnel from "../../services/funnel-service.js";
const template = `
    <div v-show="fs.display(input)" class="input-container">
        <div v-if="input.type != 'hidden'" aria-live="polite" aria-atomic="true" class="sr-only" :id="input.id+'_announcer'"></div>
        
        <qt-label v-if="!isTruthy(input.hidden)" :iuid="iuid"></qt-label>
        <input
            :id="iuid"
            :class="computedInputClass"
            :name="input.element_name"
            :type="getType()"
            :placeholder="input.placeholder"
            :pattern="input.input_pattern"
            :required="input.validation.required"
            :disabled="input.disabled"
            :readonly="input.readonly"
            :value="input.value"
            @input="exec($event, input)"
            @click="maskaFunc($event, input)"
            @blur="exec($event, input)"
            @focus="exec($event, input)"
            v-maska="computedMask"
            @maska="maskaFunc($event, input)"
            v-bind="validationRules"
            :data-uid="input.uid"
            :aria-required="input.validation.required"
            :aria-labelledby="'label_'+input.uid"
            :aria-describedby="input.id+'_announcer'"
        />
    </div>
`;

export default {
    name: 'qt-input-text',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    components: {
        'qt-label': Label
    },
    data() {
        return {
            raw_value: '',
        }
    },
    watch: {
        raw_value: function (newVal, oldVal) {
            if (newVal) {
                this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'raw_value', val: this.raw_value });
            }
        }
    },
    mounted: function () {
        this.handleIIFE();
    },
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        validationRules() {
            // v-bind="validationRules"
            return this.input.validation
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        computedInputClass: function () {

            var statusClass = '';

            if (this.input.value) {
                statusClass = 'complete'
            }
            return statusClass
        },
        computedMask: function () {

            var mask_obj

            if (this.input.validation.mask) {
                mask_obj = {}
                mask_obj.mask = this.input.validation.mask
            }
            if (this.input.validation.tokens) {
                mask_obj.tokens = this.input.validation.tokens
            }
            // credit card dynamic masking. -G
            if (this.input.type == 'cc') {
                console.log(this.input.uid+ " card type: ", this.fs.identifyCardType(this.input));
                if (this.fs.identifyCardType(this.input) === "American Express") {
                    console.log('isamex');
                    mask_obj = {}
                    mask_obj.mask = "#### ###### #####"
                } 
                else{
                    console.log('regularcc');
                    mask_obj = {}
                    mask_obj.mask = "#### #### #### ####"
                }
            }
            

            if (this.input.type === 'cvv') {
                let ccv_ref_input = this.$store.getters.funnel.elements[this.input.cc_ref_uid]

                console.log("ref input: ",ccv_ref_input );
                if (this.fs.identifyCardType(ccv_ref_input) == "American Express") {
                    console.log('isamex cvv');
                    mask_obj = {}
                    mask_obj.mask = "####"
                } 
                else{
                    console.log('regularcc cvv');
                    mask_obj = {}
                    mask_obj.mask = "###"
                }
            }
            

            return mask_obj
        }
    },
    methods: {
        maskaFunc: function (event, input) {
            if (input.validation.mask) {
                this.raw_value = event.target.dataset.maskRawValue
                this.fs.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'raw_value', val: this.raw_value })
                var self = this;
                this.$nextTick(function () {
                    self.maskedInput(event, input)
                })
            }
        },
        maskedInput: function (event, input) {
            if (!input.raw_value) {
                this.fs.ctx.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'value', val: input.raw_value })
                return
            }

            var elem = event.target;
            var raw_value = elem.getAttribute('data-mask-raw-value');
            var last_raw = raw_value[raw_value.length - 1]
            var end_masked_string_pos = input.value.lastIndexOf(last_raw) + 1;

            elem.selectionStart = elem.selectionEnd = end_masked_string_pos
            // elem.focus()
        },
        getType: function () {
            var type = 'text';
            if (Utils.isTruthy(this.input.hidden)) {
                type = 'hidden';
            }
            if (this.input.type === 'tel' || this.input.type === 'number' || this.input.type === 'email') {
                type = this.input.type
            }
            return type;
        }
    }
};
